import * as React from 'react';
import { Component } from 'react';
// tslint:disable-next-line:import-name
import YouTube from 'react-youtube';
import HowItWorksContentUI from './HowItWorksContentUI';


export interface IVideoOpts {
    dealerVideoId: string;
    videoOpts: {
        width: string;
        height: string;
        playerVars: {
            modestbranding: number;
            rel: number;
        }
    };
}

export interface IHowItWorksUIProps {
    dealerVideoId?: string;
    videoOpts?: IVideoOpts;
}

export interface IHowItWorksState {
}

class HowItWorksUI extends Component<IHowItWorksUIProps, IHowItWorksState> {

    constructor(props) {
        super(props);
    }

    render() {
        const { dealerVideoId, videoOpts } = this.props;
        return (
            <div className="how-it-works-content-container">
                <div className="how-it-works-video-container">
                    <YouTube
                        videoId={dealerVideoId}
                        opts={videoOpts}
                    />
                </div>
                <div className="how-it-works-content">
                    <HowItWorksContentUI
                        cardHeading="Customize Your Payments"
                        secondaryText="Get a realistic payment based on your info."
                        iconType="offer"
                    />
                    <HowItWorksContentUI
                        cardHeading="Value Your Trade-In"
                        secondaryText="See what Kelley Blue Book says your car is worth."
                        iconType="how-it-works-trade-icon"
                    />
                    <HowItWorksContentUI
                        cardHeading="Apply for Financing"
                        secondaryText="Choose from options that meet your needs. "
                        iconType="credit"
                    />
                    <HowItWorksContentUI
                        cardHeading="Schedule a Test Drive"
                        secondaryText="Have a car waiting when you arrive."
                        iconType="schedule"
                    />
                    <HowItWorksContentUI
                        cardHeading="Enjoy your new ride!"
                        secondaryText=""
                        iconType="how-it-works-enjoy-icon"
                        isFinal={true}
                    />
                </div>
            </div>

        );
    }

}

export default HowItWorksUI;
